import TopNav from "@/components/TopNav";

export default function SimpleTopBar({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <TopNav />
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  );
}
